(ns practitest.frontend.integration-settings.sub-tabs
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.subs :as subs]
            [practitest.frontend.navigation :as navigation]
            [practitest.frontend.components.project-settings-tabs :as project-settings-tabs]))

(defn sub-tabs
  [{:keys [active tabs bugtracker-label identifier extra-offset?]}]
  (when (seq tabs)
    (let [app-options @(re-frame/subscribe [::subs/options])]
      [navigation/css-loaded-wrapper
       (:css-path app-options)
       [:div.integration-settings-sticky-header
        {:class (when extra-offset? "integration-settings-sticky-header--deep")}
        [:div.integration-settings-header
         [:span.integration-settings-header-title
          [:span.integration-settings-header-bugtracker bugtracker-label]
          " - " identifier]]
        [project-settings-tabs/settings-tab-strip tabs active false nil true]]])))
